import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 获取和筛选成果信息列表
export function getTradingInfo(params, data) {
  const url = handlerGetUrlParams('/bus/operation/home/list', params)
  // console.log(data)
  return request({
    url,
    method: 'POST',
    data
  })
}

// 获取成果交易浏览量
export function viewResultInfo(id) {
  return request({
    url: `/bus/operation/is_view/${id}`,
    method: 'PUT'
  })
}

// 获取id成果详细信息
export function getDetailInfo(id) {
  return request({
    url: `/bus/operation/home/${id}`,
    method: 'GET'
  })
}

// 获取成果热点文章
export function getHotInfo() {
  return request({
    url: '/bus/operation/Hotlist',
    method: 'GET'
  })
}

export function getLicenceInfo(params, data) {
  const url = handlerGetUrlParams('/bus/open/home/list', params)
  return request({
    url,
    method: 'POST',
    data
  })
}
// 获取开放许可交易浏览量
export function viewLincenceResultInfo(id) {
  return request({
    url: `/bus/open/is_view/${id}`,
    method: 'PUT'
  })
}

// 获取开放许可详细信息
export function getLincenceDetailInfo(id) {
  return request({
    url: `/bus/open/home/${id}`,
    method: 'GET'
  })
}

// 获取开放许可热点文章
export function getLincenceHotInfo() {
  return request({
    url: '/bus/open/Hotlist',
    method: 'GET'
  })
}

// 收藏和取消收藏运营信息
export function collectTradingInfo(data) {
  return request({
    url: '/bus/collect/collect',
    method: 'POST',
    data
  })
}

// 需求列表浏览量
export function viewDemandInfo(id) {
  return request({
    url: `/bus/demands/is_view/${id}`,
    method: 'PUT'
  })
}

// 获取和筛选交易市场需求信息列表
export function getDemandsInfo(params, data) {
  const url = handlerGetUrlParams('/bus/demands/home/list', params)
  return request({
    url,
    method: 'POST',
    data
  })
}

// 获取id需求详细信息
export function getDemandInfo(id) {
  return request({
    url: `/bus/demands/home/${id}`,
    method: 'GET'
  })
}

// 需求信息热门标签
export function getDemandHottagInfo() {
  return request({
    url: `/bus/demands/hotTag`,
    method: 'GET'
  })
}

// 获取交易公告信息
export function getTransInfo(id) {
  return request({
    url: `/bus/tradePublicity/publishlist?searchValue=${id}`,
    method: 'GET'
  })
}

// 获取更多交易公告信息
export function getMoreTransInfo(params) {
  const url = handlerGetUrlParams('/bus/tradePublicity/publishlist', params)
  return request({
    url,
    method: 'GET'
  })
}

// 获取行业咨询信息
export function getIndustryInfo(id) {
  return request({
    url: `/bus/information/industrylist?searchValue=${id}`,
    method: 'GET'
  })
}

// 获取行业咨询信息
export function getAnnounceInfo(id) {
  return request({
    url: `/bus/tradePublicity/publishInfo/${id}`,
    method: 'GET'
  })
}
